export default "__VITE_ASSET__CC$8HkMi__"